import LayoutComp from 'components/LayoutComp/Index';
import React, { useEffect, useState } from 'react';
import { STATIC_TEXT } from 'utils/constants';
import { BackArrow } from 'utils/svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchYears, fetchquestionnaireNames } from 'containers/QuestionCategory/category.action';
import { Table, Button, Input, Space, Select } from 'antd';
import { CloudDownloadOutlined, EditOutlined } from '@ant-design/icons';
import Loader from 'components/ui/Loader';
import { CloudUploadOutlined } from '@ant-design/icons';
import './styles.scss';
import { UpdateQuestionnaire, downloadImportFile } from './manageques.action';
import ImportModal from './Components/ImportModal';

const ManageQuestions = ({ history }) => {
  const dispatch = useDispatch();
  const categoriesState = useSelector((state) => state.category);
  const loading = useSelector((state) => state.manageques.loading);
  const { questionLoader = false, questionnaireNames = [], years = [] } = categoriesState;
  const [activeYear, setActiveYear] = useState(null);
  const [columns, setColumns] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [nameInput, setNameInput] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentQues, setCurrentQues] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    dispatch(fetchYears());
    // eslint-disable-next-line
  }, [dispatch]);

  const handleBack = () => {
    history.push('/');
  };

  useEffect(() => {
    if (years.length > 0) {
      const firstyear = years[0];
      setActiveYear(firstyear);
      dispatch(fetchquestionnaireNames(firstyear));
    }
    // eslint-disable-next-line
  }, [years]);

  const handleDownload = async (record) => {
    // console.log("record", record)
    try {
      await dispatch(downloadImportFile(record?.id));
    } catch (error) {
      console.error("Error downloading file", error);
    }
  }


  useEffect(() => {
    if (questionnaireNames.length > 0) {
      const dynamicColumns = Object.keys(questionnaireNames[0]).map((key) => ({
        title: key.charAt(0).toUpperCase() + key.slice(1),
        dataIndex: key,
        key: key
      }));

      dynamicColumns.forEach((column) => {
        if (column.dataIndex === 'id' || column.dataIndex === 'action') {
          column.width = 75;
        }
      });

      dynamicColumns.push({
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          <>
            <Space size="middle">
              <Button onClick={() => handleUpdate(record)} type="primary">
                <CloudUploadOutlined />
                Update
              </Button>
              <Button type="primary" onClick={() => handleDownload(record)}>
                <CloudDownloadOutlined />
                Download
              </Button>
            </Space>
          </>
        ),
        width: 290
      });

      const nameColumn = dynamicColumns.find((col) => col.dataIndex === 'name');
      if (nameColumn) {
        nameColumn.render = (text, record) => (
          <Space>
            {/* Show Name */}
            {editingKey === record.id ? (
              <Input
                value={nameInput}
                onChange={(e) => setNameInput(e.target.value)}
                style={{ width: 350 }}
              />
            ) : (
              text
            )}
            {/* Show Edit Icon */}
            {editingKey !== record.id && (
              <EditOutlined
                onClick={() => handleEdit(record)}
                style={{ cursor: 'pointer', color: '#7438f2' }}
              />
            )}
            {/* Show Save Button */}
            {editingKey === record.id && (
              <Button onClick={() => handleSave(record)} size="small" type="primary">
                Save
              </Button>
            )}
          </Space>
        );
      }

      setColumns(dynamicColumns);
    }
    // eslint-disable-next-line
  }, [questionnaireNames, editingKey, nameInput]);

  const handleEdit = (record) => {
    setEditingKey(record.id);
    setNameInput(record.name);
  };
  const handleUpdate = (record) => {
    setIsEdit(true);
    setCurrentQues(record);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setCurrentQues({});
    setIsEdit(false);
    setIsModalOpen(false);
  };

  const handleSave = async (record) => {
    try {
      const payload = {
        id: record.id,
        title: nameInput,
        description: '',
        year: activeYear
      };
      await dispatch(UpdateQuestionnaire(payload));
      dispatch(fetchquestionnaireNames(activeYear));
      setEditingKey('');
      setNameInput('');
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };
  const showModal = () => {
    setIsModalOpen(true);
  };

  const renderTable = () => {
    if (questionLoader) {
      return <Loader />;
    }

    return <Table dataSource={questionnaireNames} bordered columns={columns} rowKey="id" />;
  };

  const handleYearChange = (val) => {
    setActiveYear(val);
    dispatch(fetchquestionnaireNames(val));
  };

  return (
    <LayoutComp history={history}>
      <div id="managequestions">
        <div className="back-nav">
          <div onClick={handleBack}>
            <BackArrow />
          </div>
          {STATIC_TEXT['MANAGE_QUESTIONS']}
        </div>
        {questionLoader && <Loader />}
        <div className="tablewrapper">
          <div className="top-action">
            <div className="yeardropdown">
              Select Years &nbsp;
              <Select
                size="small"
                onChange={handleYearChange}
                value={activeYear}
                style={{ width: 100 }}
                options={years.map((item) => {
                  return { value: item, label: item };
                })}
              />
            </div>
            <div style={{ display: 'flex', gap: '5px' }}>
              <Button type="primary" onClick={showModal}>
                <CloudUploadOutlined />
                Upload
              </Button>
            </div>
          </div>
          {renderTable()}
        </div>
        <ImportModal
          isModalOpen={isModalOpen}
          handleCancel={handleCancel}
          loader={loading}
          years={years}
          currentQues={currentQues}
          activeYear={activeYear}
          isEdit={isEdit}
        />
      </div>
    </LayoutComp>
  );
};

export default ManageQuestions;
